/** Parses a space-separated list of bytes in binary, decimal or hex. */
export const parseByteList = (list: string, radix: number): { bytes?: Uint8Array; error?: string; short?: boolean } => {
  const tokens = list.trim().split(/\s+/).filter(Boolean);
  const valid = radix === 2 ? /^[01]{1,8}$/ : radix === 16 ? /^[0-9a-fA-F]{1,2}$/ : /^\d{1,3}$/;
  const label = radix === 2 ? "binary (0 and 1, up to 8 digits)" : radix === 16 ? "hex (00 to ff)" : "decimal (0 to 255)";
  const out = new Uint8Array(tokens.length);
  let short = false;
  for (let i = 0; i < tokens.length; i++) {
    const t = tokens[i];
    if (!valid.test(t) || parseInt(t, radix) > 255) {
      return { error: `"${t.length > 12 ? t.slice(0, 12) + "…" : t}" (item ${i + 1}) is not a valid ${label} byte. Separate bytes with spaces.` };
    }
    if (radix === 2 && t.length < 8) short = true;
    out[i] = parseInt(t, radix);
  }
  return { bytes: out, short };
};
